

export const tedReviewerReviewHinge = {
  _id: 'tedReviewerReviewHingeId',
  email: 'ted@email.com',
  profileReviewId: 'tedProfileReviewHingeId',
  reviewerProfileId: 'tedReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Ted! This will really help me!',
  profileReviewedFirstName: 'Barney',
}

export const tedReviewerReviewBumble = {
  _id: 'tedReviewerReviewBumbleId',
  email: 'ted@email.com',
  profileReviewId: 'tedProfileReviewBumbleId',
  reviewerProfileId: 'tedReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Ted! This will really help me!',
  profileReviewedFirstName: 'Barney',
}

export const robinReviewerReviewTinder = {
  _id: 'robinReviewerReviewTinderId',
  email: 'robin@email.com',
  profileReviewId: 'robinProfileReviewTinderId',
  reviewerProfileId: 'robinReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Robin! This will really help me!',
  profileReviewedFirstName: 'Barney',
}